module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAh0lEQVQoU2NkIBEwkqiegU4aJs5cFMXA8HcxAwMDEw4n/mNkZEjOS0tcAHZS38z5ukwM/w8zMjDyY9Pwn+H/x/+MjA6FaYkX4H6YNGeh2b+/f3ehawIpZmJmdstLiT8FMgzF0+ia0BVjaAAJwDSB2Mgmw5yKNVj7Zy6WBCkoTI99ju4n2scDAJwAMw02jRUVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-arrow.png
// module id = qF38
// module chunks = 4